import * as React from "react";
import { useState } from "react";
import HeaderBar from "../commons/components/HeaderBar";
import { AvailableEntitiesSettings } from "../commons/model/EntitySettings";
import LoadingSpinner from "../flow/utils/LoadingSpinner";

interface SettingViewProps {
  title: string;
  entities: AvailableEntitiesSettings;
  children: React.ReactElement;
}

export default function SettingsView(props: SettingViewProps) {
  const [loading, setLoading] = useState(false);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="settings-customisation v-flex no-wrap">
      <HeaderBar
        title={props.title}
        entities={props.entities}
        onChange={() => {
          setLoading(true);
        }}
      />
      <div className="container">{props.children}</div>
    </div>
  );
}
